import { useParams } from "react-router-dom";
import {
  useGetBranchesQuery,
  useGetCountriesQuery,
  useGetReservationDetailsQuery,
  useGetTripTypesQuery,
} from "../../redux/Service/api";
import { Button, message } from "antd";
import { useState } from "react";
import AddReservationModal from "./AddReservationModal";
import { useSelector } from "react-redux";

const ServiceDetails = () => {
  // Get the service ID from the URL parameters
  const { serviceId } = useParams();
  const userData = useSelector((state: any) => state.auth.userData);
  const [openAddReservationModal, setOpenAddReservationModal] = useState(false);

  // Fetching related data
  const {
    data: serviceDetailsData,
    isLoading: isServiceDetailsLoading,
    isError: isServiceDetailsError,
  } = useGetReservationDetailsQuery(serviceId);
  const { data: branchesData } = useGetBranchesQuery(undefined);
  const { data: countriesData } = useGetCountriesQuery(undefined);
  const { data: tripTypesData } = useGetTripTypesQuery(undefined);

  // Process the data
  const serviceDetails = serviceDetailsData?.ResponseObject
    ? serviceDetailsData?.ResponseObject?.[0]
    : {};

  console.log(serviceDetails);

  const branches = branchesData?.ResponseObject ?? [];
  const countries = countriesData?.ResponseObject ?? [];
  const tripTypes = tripTypesData?.ResponseObject ?? [];

  const getBranchNameById = (branchId: any) => {
    const branch = branches.find((branch: any) => branch.BranchID === branchId);
    return branch ? branch.BranchName : "غير معروف";
  };

  const getTripTypeNameById = (tripTypeId: any) => {
    const tripType = tripTypes.find(
      (type: any) => type.TripTypeID === tripTypeId
    );
    return tripType ? tripType.TripTypeName : "غير معروف";
  };

  const getCountryNameById = (countryId: any) => {
    const country = countries.find(
      (country: any) => country.CountryID === countryId
    );
    return country ? country.CountryName : "غير معروف";
  };

  if (isServiceDetailsLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">Loading service details...</p>
      </div>
    );
  }

  if (isServiceDetailsError) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-red-500">
          Failed to load service details. Please try again.
        </p>
      </div>
    );
  }

  if (!serviceDetails) {
    return (
      <div className="flex items-center justify-center h-[64vh]">
        <p className="text-gray-500 font-bold text-4xl">
          تفاصيل الخدمة غير موجودة
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-10 mt-10">
      {/* Section Title */}
      <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-8">
        تفاصيل الخدمة
      </h2>

      {/* Service Details List */}
      <div className="space-y-8">
        <div
          key={serviceDetails.ReserveID}
          className="bg-white p-8 rounded-lg shadow-lg border-l-4 border-blue-600 transition-shadow duration-300"
        >
          <div className="mb-5">
            <h3 className="text-xl font-semibold text-blue-700 mb-3">
              {getTripTypeNameById(serviceDetails.TripTypeID)}
            </h3>
            <p className="text-lg font-semibold text-gray-800 mb-2">
              <strong>رقم الرحلة:</strong> {serviceDetails.TripNo}
            </p>
            <p className="text-lg text-gray-700 mb-2">
              <strong>تاريخ الحجز:</strong>{" "}
              {new Date(serviceDetails.ReserveDate).toLocaleDateString("ar-EG")}
            </p>
            <p className="text-lg text-gray-700 mb-2">
              <strong>تاريخ الرحلة:</strong>{" "}
              {new Date(serviceDetails.TripDate).toLocaleDateString("ar-EG")}
            </p>
          </div>

          <div className="mb-5">
            <p className="text-lg text-gray-700 mb-2">
              <strong className="text-gray-800">من الفرع:</strong>{" "}
              {getBranchNameById(serviceDetails.BranchID)}
            </p>
            <p className="text-lg text-gray-700 mb-2">
              <strong className="text-gray-800">من البلد:</strong>{" "}
              {getCountryNameById(serviceDetails.CountryFromID)}
            </p>
            <p className="text-lg text-gray-700 mb-2">
              <strong className="text-gray-800">إلى البلد:</strong>{" "}
              {getCountryNameById(serviceDetails.CountryToID)}
            </p>
            <p className="text-lg text-gray-700 mb-2">
              <strong className="text-gray-800">عدد الأشخاص:</strong>{" "}
              {serviceDetails.PersonsCount}
            </p>
          </div>

          <div>
            <p className="text-lg text-gray-700 mb-2">
              <strong className="text-gray-800">ملاحظات:</strong>{" "}
              {serviceDetails.Notes}
            </p>
          </div>
        </div>

        <Button
          type="primary"
          size="large"
          onClick={() => {
            if (userData) {
              setOpenAddReservationModal(true);
            } else {
              message.error("يرجى تسجيل الدخول للحجز");
            }
          }}
        >
          حجز
        </Button>
      </div>

      <AddReservationModal
        open={openAddReservationModal}
        setOpen={setOpenAddReservationModal}
        branchName={getBranchNameById(serviceDetails.BranchID)}
        customerId={userData?.UserID}
        countryFromName={getCountryNameById(serviceDetails.CountryFromID)}
        countryToName={getCountryNameById(serviceDetails.CountryToID)}
        tripTypeName={getTripTypeNameById(serviceDetails.TripTypeID)}
        tripName={serviceDetails.TripNo}
      />
    </div>
  );
};

export default ServiceDetails;
